import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import { Link } from "react-router-dom";
import axios from "axios";
import { IoSearchOutline } from "react-icons/io5";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import AdminNav from "./AdminNav";

const Withdrawals = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [allWithdraws, setAllWithdraws] = useState([]);
  const [filteredWithdraws, setFilteredWithdraws] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const token = localStorage.getItem("admintoken");
  // Fetch  Withdraw data
  useEffect(() => {
    const fetchWithdrawData = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/withdraw/get-withdraws`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (data?.success) {
          const sortedWithdraws = data.withdrawRequests.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setAllWithdraws(sortedWithdraws);
          setFilteredWithdraws(sortedWithdraws);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchWithdrawData();
  }, [token]);

  // Handle Search
  useEffect(() => {
    const searchQuery = searchTerm.trim().toLowerCase();
    const filtered = searchQuery
      ? allWithdraws.filter((withdraw) => {
          const userName = `${withdraw.name}`.toLowerCase();
          const userEmail = withdraw.email?.toLowerCase() || "";

          const withdrawDate = new Date(withdraw.createdAt)
            .toLocaleString()
            .toLowerCase();

          return (
            userName.includes(searchQuery) ||
            userEmail.includes(searchQuery) ||
            withdrawDate.includes(searchQuery)
          );
        })
      : allWithdraws;

    setFilteredWithdraws(filtered);
  }, [searchTerm, allWithdraws]);

  const getWithdrawClass = (withdrawstatus) => {
    switch (withdrawstatus) {
      case "pending":
        return "kyc-pending";
      case "approved":
        return "kyc-verified";
      case "rejected":
        return "kyc-rejected";
      default:
        return "";
    }
  };

  return (
    <div className="wrapper d-flex align-items-stretch">
      {loading && <Loader />}
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="content" className="px-2">
        <button
          type="button"
          id="openSidebar"
          onClick={toggleSidebar}
          className="bars-btn"
        >
          <FaBarsStaggered />
        </button>
        <AdminNav />
        <h3 className="b-clr">Pending Withdrawal Requests</h3>
        <div className="search-add-main">
          <div className="search-main">
            <input
              type="text"
              className="search-inp"
              placeholder="Search by name, email, date..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="search-icon">
              <IoSearchOutline />
            </div>
          </div>
        </div>

        <div className="tbl-main">
          <table className="simple-table">
            <thead>
              <tr>
                <th>NAME</th>
                <th>EMAIL</th>
                <th>DATE</th>
                <th>ACTIONS</th>
                <th>STATUS</th>
              </tr>
            </thead>
            <tbody>
              {filteredWithdraws.length > 0 ? (
                filteredWithdraws.map((withdraw) => (
                  <tr key={withdraw._id}>
                    <td>{`${withdraw?.userId?.name} `}</td>
                    <td>{withdraw?.userId?.email}</td>

                    <td>{new Date(withdraw.createdAt).toLocaleString()}</td>
                    <td>
                      <Link
                        className="btn btn-primary"
                        to={
                          withdraw.currency
                            ? `/dashboard/admin/withdraw-details/${withdraw._id}`
                            : `/dashboard/admin/withdraw-details-c/${withdraw._id}`
                        }
                      >
                        Details
                      </Link>
                    </td>

                    <td>
                      <span
                        className={`kyc-status ${getWithdrawClass(
                          withdraw.status
                        )}`}
                      >
                        {withdraw.status}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Withdrawal requests found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Withdrawals;
